import {
  GET_TERMS_OF_SERVICE,
  GET_TERMS_OF_SERVICE_SUCCESS,
  GET_TERMS_OF_SERVICE_ERROR,
  POST_TERMS_OF_SERVICE,
  POST_TERMS_OF_SERVICE_SUCCESS,
  POST_TERMS_OF_SERVICE_ERROR,
  GET_LATEST_TERMS_OF_SERVICE,
  GET_LATEST_TERMS_OF_SERVICE_SUCCESS,
  GET_LATEST_TERMS_OF_SERVICE_ERROR,
  GET_USER_TERMS_OF_SERVICE,
  GET_USER_TERMS_OF_SERVICE_SUCCESS,
  GET_USER_TERMS_OF_SERVICE_ERROR,
  CREATE_USER_TERMS_OF_SERVICE,
  CREATE_USER_TERMS_OF_SERVICE_SUCCESS,
  CREATE_USER_TERMS_OF_SERVICE_ERROR
} from "./actionTypes"


// For Get insurance_carriers
export const getTermsOfService = () => ({
  type: GET_TERMS_OF_SERVICE,
})

export const getTermsOfServiceSuccess = (response) => ({
  type: GET_TERMS_OF_SERVICE_SUCCESS,
  payload: response
})

export const getTermsOfServiceError = (error) => ({
  type: GET_TERMS_OF_SERVICE_ERROR,
  payload: error
})

// For Post insurance_carriers

export const postTermsOfService = (data) => ({
  type: POST_TERMS_OF_SERVICE,
  payload: data
})

export const postTermsOfServiceSuccess = (response) => ({
  type: POST_TERMS_OF_SERVICE_SUCCESS,
  payload: response
})

export const postTermsOfServiceError = (error) => ({
  type: POST_TERMS_OF_SERVICE_ERROR,
  payload: error
})

// For Get latest terms-of-service

export const getLatestTermsOfService = () => ({
  type: GET_LATEST_TERMS_OF_SERVICE,
})

export const getLatestTermsOfServiceSuccess = (response) => ({
  type: GET_LATEST_TERMS_OF_SERVICE_SUCCESS,
  payload: response
})

export const getLatestTermsOfServiceError = (error) => ({
  type: GET_LATEST_TERMS_OF_SERVICE_ERROR,
  payload: error
})

export const getUserTermsOfService = () => {
  return {
    type: GET_USER_TERMS_OF_SERVICE,
  }
}

export const getUserTermsOfServiceSuccess = (response) => ({
  type: GET_USER_TERMS_OF_SERVICE_SUCCESS,
  payload: response
})

export const getUserTermsOfServiceError = (error) => ({
  type: GET_USER_TERMS_OF_SERVICE_ERROR,
  payload: error
})

export const createUserTermsOfService = (data) => ({
  type: CREATE_USER_TERMS_OF_SERVICE,
  payload: data
})

export const createUserTermsOfServiceSuccess = (response) => ({
  type: CREATE_USER_TERMS_OF_SERVICE_SUCCESS,
  payload: response
})

export const createUserTermsOfServiceError = (error) => ({
  type: CREATE_USER_TERMS_OF_SERVICE_ERROR,
  payload: error
})